import { ITheme } from '@/theme/interfaces/ITheme'

const parseRgb = (rgbString: string): [number, number, number] | null => {
  const match = rgbString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
  if (!match) {
    return null
  }
  return [
    parseInt(match[1], 10),
    parseInt(match[2], 10),
    parseInt(match[3], 10)
  ]
}

export const getContrastColor = (rgbString: string, theme: ITheme): string => {
  const rgb = parseRgb(rgbString)
  if (!rgb) {
    return theme.colors.onBackground
  }

  const [r, g, b] = rgb
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  return luminance > 0.6 ? theme.colors.onBackground : theme.colors.background
}
